module.exports = __webpack_public_path__ + "img/02.03da33c1.jpg";